import { Home, Sparkles, ShieldCheck, HeartHandshake } from "lucide-react";

const items = [
  {
    icon: Home,
    title: "At your door",
    body: "A discreet, fully-equipped mobile setup. No traffic, no carparks, no rushing back into the world.",
  },
  {
    icon: Sparkles,
    title: "Considered actives",
    body: "Professional-grade products and protocols, chosen for results — not for trend.",
  },
  {
    icon: ShieldCheck,
    title: "Trained & trusted",
    body: "Years of in-clinic experience, brought into your home with strict hygiene and clinical care.",
  },
  {
    icon: HeartHandshake,
    title: "Quietly personal",
    body: "An unhurried, deeply attentive service shaped around your skin, your space, your day.",
  },
];

export default function Philosophy() {
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-[#4A3737] text-[#FAEDE6] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-8 bg-[#C5A8A4]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C5A8A4]">
              Why Amber
            </span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[58px] font-light leading-[1.05] tracking-tight text-[#FAEDE6]">
            The studio,
            <br />
            <em className="not-italic font-script text-[#C5A8A4] text-5xl md:text-6xl lg:text-[64px]">
              reimagined for home.
            </em>
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-14">
          {items.map(({ icon: Icon, title, body }) => (
            <div key={title} className="border-t border-[#C5A8A4]/30 pt-6">
              <Icon size={22} className="text-[#C5A8A4]" strokeWidth={1.25} />
              <h3 className="mt-6 font-serif-display text-2xl md:text-[28px] font-light text-[#FAEDE6] leading-tight">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#FAEDE6]/75 font-light">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
